<!-- 
Quick search text box.

Quick searches allow search criteria to be typed into the box and will 
perform the search automatically after a short debounce period.
-->
<template>
  <v-tooltip bottom>
    <v-text-field 
      slot="activator"
      :value="value"
      :placeholder="label"
      class="mb-3 mt-1 compact"
      height="40"
      prepend-inner-icon="search"
      outline clearable hide-details single-line
      @input="changed"
    />
    <span>Enter {{ label.toLowerCase() }} here to perform a quick search.</span>
  </v-tooltip>
</template>

<script>
import _ from "underscore";
import { integer } from "@/helpers/rule.helper";

export default {
  props: {
    criteriaMutation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    fieldIfNumeric: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  methods: {
    changed(v) {
      if (this.fieldIfNumeric) {
        const isNumber = v && integer(v) == true && v.length < 10;
        const d = isNumber
          ? { [this.field]: null, [this.fieldIfNumeric]: v }
          : { [this.field]: v, [this.fieldIfNumeric]: null };
        this.$store.commit(this.criteriaMutation, d);
      } else {
        this.$store.commit(this.criteriaMutation, { [this.field]: v });
      }
      this.fireChangeEvent();
    },
    fireChangeEvent: _.debounce(function() {
      this.$emit("changed");
    }, 500)
  }
};
</script>
